var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    colors = _ref.colors,
    typography = _ref.typography,
    breakpoints = _ref.breakpoints;
  return {
    navPaddingTopBottom: spacing.small,
    navPaddingLeftRight: spacing.xLarge,
    navBorderWidth: borders.widthSmall,
    navBorderColor: colors.tiara,
    navBackgroundColor: colors.white,
    bankIconColor: colors.electric,
    bankIconFontSize: typography.fontSizeLarge,
    bankIconPadding: spacing.xSmall
  };
};
export default generateComponentTheme;